/**
 *
 * Module:        Component
 * Name:          Guru Chat Action Menu Items
 * Description:   Renders the shared rename, pin and delete actions for a Guru chat menu
 * Developers:    Adrian Engelmann, Kiran Jayaramu, Nicu Bratescu, Daniela Popescu
 * Copyright:     Copyright 2026 by Qalgo GmbH (www.qalgo.de). All rights reserved.
 *
 */

import React from 'react';
import {ListItemIcon, ListItemText, MenuItem} from '@mui/material';
import EditOutlinedIcon from '@mui/icons-material/EditOutlined';
import PushPinOutlinedIcon from '@mui/icons-material/PushPinOutlined';
import PushPinIcon from '@mui/icons-material/PushPin';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';

export default function GuruChatActionMenuItems({
	chat,
	labels,
	disabled=false,
	onRename,
	onTogglePin,
	onDelete,
	onAction
}) {
	if (!chat) return null;

	const run = callback => {
		if (disabled || typeof callback !== 'function') return;
		if (typeof onAction === 'function') onAction();
		callback(chat);
	};

	return (
		<>
			<MenuItem disabled={disabled} onClick={() => run(onRename)}>
				<ListItemIcon><EditOutlinedIcon fontSize="small" /></ListItemIcon>
				<ListItemText>{labels.renameChat}</ListItemText>
			</MenuItem>
			<MenuItem disabled={disabled} onClick={() => run(onTogglePin)}>
				<ListItemIcon>{chat.pinned
					? <PushPinIcon fontSize="small" />
					: <PushPinOutlinedIcon fontSize="small" />}</ListItemIcon>
				<ListItemText>{chat.pinned ? labels.unpinChat : labels.pinChat}</ListItemText>
			</MenuItem>
			<MenuItem className="guru-chat-delete-action" disabled={disabled} onClick={() => run(onDelete)} sx={{color: 'error.main'}}>
				<ListItemIcon sx={{color: 'error.main'}}><DeleteOutlineIcon fontSize="small" /></ListItemIcon>
				<ListItemText>{labels.deleteChat}</ListItemText>
			</MenuItem>
		</>
	);
}
